import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'admin-v2';
  env: any;
  constructor() {
    this.env = environment;
    if (this.env.env === 'staging') {
      document.title = 'TL-V2(Staging)';
    }
  }

  ngOnInit(): void {
    console.log('Component Initialized');

    // Check if the page was reloaded
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      // console.log('Page was reloaded!');

      // Clear all IndexedDB databases
      const indexedDBDeleteRequest = indexedDB.databases();

      indexedDBDeleteRequest
        .then((databases) => {
          databases.forEach((db) => {
            indexedDB.deleteDatabase(db.name);
            console.log(`Deleted database: ${db.name}`);
          });
        })
        .catch((error) => {
          console.error('Error clearing IndexedDB:', error);
        });
    }
  }
}
